import getAxiosInstance from "../../common/mhiAxios";
import { BackendList } from "./model/Program";

export default {
    //受講中プログラム取得
    GetLearningProgramList(userId: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getLearningChannelVideoList", { params: { userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 指定のプログラムにビデオを追加
    AddVideoToProgram(
        userId: string,
        programId: string,
        videoId: string,
        videoType: number
    ): Promise<void> {
        return getAxiosInstance()
            .post("/api/addVideoToChannel", {
                userId: userId,
                programId: programId,
                videoId: videoId,
                videoType: videoType,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //プログラム一覧取得
    GetAllProgram(userId: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getAllChannel", { params: { userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //プログラム更新
    UpdateProgram(
        userId: string,
        updateListItems: BackendList[],
        deleteListIdItems: number[]
    ): Promise<any> {
        const params = new FormData();
        params.append("userId", userId);

        if (updateListItems.length === 0) {
            // プログラム全件削除の場合
            const program: string = JSON.stringify({
                "updateProgramList": [],
                "deleteProgramIdList": deleteListIdItems
            });
            params.append("program", new Blob([program], { type: "application/json" }));
        } else {
            const sendPrograms: object[] = [];

            // 追加のアイテム
            updateListItems.map((row) => {
                params.append(
                    "file",
                    row.file === null || row.file === undefined ? new File([""], "empty") : row.file
                );

                sendPrograms.push({
                    id: row.id,
                    title: row.title,
                    description: row.description,
                    imageUrl: row.imageUrl,
                    videoIds: row.videoIds,
                    relatedVideoIds: row.relatedVideoIds,
                    updateFlag: row.updateFlag || false
                });
                return null;
            });

            // 追加と削除のアイテムをまとめる
            const program: string = JSON.stringify({
                "updateProgramList": sendPrograms,
                "deleteProgramIdList": deleteListIdItems
            });
            params.append("program", new Blob([program], { type: "application/json" }));
        }

        return getAxiosInstance()
            .post("/api/updateChannel", params, {
                headers: { "content-type": "multipart/form-data" },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
